<template>
	<div class="SocialmediaCronWorksListHeader">
		<div class="ListHeaderCols">
			<div class="ListHeaderCol ListHeaderColDate">
				<v-menu ref="menu_date_start" :close-on-content-click="false" v-model="menu_date_start" :nudge-right="40"
					lazy transition="scale-transition" offset-y max-width="290px">
					<v-text-field slot="activator" v-model="date.start" label="Başlangıç Tarihi"
						prepend-icon="event" readonly hide-details width="200px"></v-text-field>
					<v-date-picker v-model="date.startISO" @input="dateStartSelected($event)" locale="tr-tr">
					</v-date-picker>
				</v-menu>
			</div>
			<div class="ListHeaderCol ListHeaderColDate">
				<v-menu ref="menu_date_end" :close-on-content-click="false" v-model="menu_date_end" :nudge-right="40" lazy
					transition="scale-transition" offset-y max-width="290px">
					<v-text-field slot="activator" v-model="date.end" label="Bitiş Tarihi"
						prepend-icon="event" readonly hide-details width="200"></v-text-field>
					<v-date-picker v-model="date.endISO" @input="dateEndSelected($event)" locale="tr-tr">
					</v-date-picker>
				</v-menu>
			</div>
			<div class="ListHeaderCol">
				<v-select :items="getBrands" v-model="brand_id" item-text="brand_name" item-value="id"  label="Marka Seç" hide-details></v-select>
			</div>
			<div class="ListHeaderCol">
				<v-checkbox v-model="only_used_days" color="dark" label="Sadece dolu günleri göster" hide-details></v-checkbox>
			</div>
			<div class="ListHeaderColSpace"> 
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name : "SocialmediaCronWorksListHeader",
	props : ["brands"],
	data : () =>({
		menu_date_start : false,
		menu_date_end : false,
		date : {
			start : "",
			startISO : "",
			end : "",
			endISO : ""
		}, 
		brand_id : "",
		only_used_days : false
	}),
	watch: {
		"date.start": function (n, o) {
			this.date.end = this.$moment( this.date.start, "DD.MM.YYYY" )
				.add(30, "days")
				.format("DD.MM.YYYY");
			this.emitChanged();
		},
		"date.end": function (n, o) {
			this.emitChanged();
		},
		"brand_id": function (n, o) {
			this.emitChanged();
		},
		"only_used_days": function (n, o) {
			this.emitChanged();
		},
	},
	mounted() {
		this.date.start = this.$moment().format("DD.MM.YYYY");
		this.date.startISO = this.$moment().format("YYYY-MM-DD");
		this.date.end = this.$moment()
			.add(30, "days")
			.format("DD.MM.YYYY");
		this.date.endISO = this.$moment()
			.add(30, "days")
			.format("YYYY-MM-DD");
	},
	methods : {
		dateStartSelected(e) {
			this.menu_date_start = false;
			this.date.start = this.$moment(e, "YYYY-MM-DD").format(
				"DD.MM.YYYY"
			);
		},
		dateEndSelected(e) {
			this.menu_date_end = false;
			this.date.end = this.$moment(e, "YYYY-MM-DD").format(
				"DD.MM.YYYY"
			);
		},
		emitChanged(){
			this.$emit("headerChanged",{
				date_start : this.date.start,
				date_end : this.date.end,
				brand_id : this.brand_id,
				only_used_days : this.only_used_days ? 1 : 0,
			})
		}
	},
	computed: { 
		getDateStartISO() {
			return this.$moment(date.start, "DD.MM.YYYY").format(
				"YYYY-MM-DD"
			);
		},
		getDateEndISO() {
			return this.$moment(date.end, "DD.MM.YYYY").format(
				"YYYY-MM-DD"
			);
		},
		getBrands(){
			var brands = [{
				"id" : "",
				"brand_name" : "Tümü"
			}]
			for(var i in this.brands){
				brands.push(this.brands[i])
			}
			return brands;
		}
	}
}
</script>


<style lang="less">
	.SocialmediaCronWorksListHeader{
		border-bottom: 2px solid #ccc;
		background-color: #fff;
		padding: 10px 10px 10px 10px;
		.ListHeaderCols{
			display: flex;
			@media(max-width:600px){
				display: block;
			}
			.ListHeaderCol{
				margin-left : 10px;
				@media(max-width:600px){
					margin-left : 0px;
				}
				&.ListHeaderColDate{
					@media(max-width:600px){
						margin-bottom:10px;
						.v-menu{
							width : 100%;
						} 
					}
				}
			}
			.ListHeaderColSpace{
				flex : 1;
			}
		}
	}
</style>
